import { render, staticRenderFns } from "./image_events.vue?vue&type=template&id=1533d23e&scoped=true&"
import script from "./image_events.vue?vue&type=script&lang=js&"
export * from "./image_events.vue?vue&type=script&lang=js&"
import style0 from "./image_events.vue?vue&type=style&index=0&id=1533d23e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1533d23e",
  null
  
)

export default component.exports